module.exports = __webpack_public_path__ + "static/img/bg_2.55628ec0.png";